import { useApiClient } from './apiClient';

export const useStudentApis = () => {
  const { get, delete:del, post, put } = useApiClient();
  
  const fetchStudents = async () => {
    try {
      const data = await get('api/studentinfos');
      
      if (!data._embedded?.studentInfoes) {
        console.error('Unexpected API response:', data);
        return [];
      }
  
      return data._embedded.studentInfoes.map(student => ({
        ...student,
        studentId: student._links.self.href.split("/").pop()
      }));
    } catch (err) {
      console.error('Error fetching students:', err);
      return [];
    }
  };
  
  const deleteStudent = async (url) => {
    try {
      return await del(url);
    } catch (err) {
      console.error("Error deleting student:", err);
      return false;
    }
  };
  
  const addStudent = async (student) => {
    try {
      return await post('api/studentinfos', student);
    } catch (err) {
      console.error("Error adding student:", err);
      return false;
    }
  };
  
  const updateStudent = async (student, link) => {
    try {
      return await put(link, student);
    } catch (err) {
      console.error("Error updating student:", err);
      return false;
    }
  };
  
  
  // Check if a studentId already exists
  const checkStudentIdExists = async (studentId) => {
    try {
      return await get(`api/studentinfos/exists?studentId=${encodeURIComponent(studentId)}`);
      } catch (err) {
        console.error("Error checking student ID:", err);
        return false;
      }
  };
  
  // Check if a studentId already exists
  const checkStudentExistsStudentIdFirstAndLastName = async (studentId, firstName, lastName) => {
    try {
      const response = await get(`api/createaccount/studentexists?studentId=${encodeURIComponent(studentId)}&firstName=${encodeURIComponent(firstName)}&lastName=${encodeURIComponent(lastName)}`);
      return response;
      } catch (err) {
        console.error("Error checking student ID:", err);
        return false;
      }
  };
  
  // Check if a studentId already exists
  const getStudentById = async (studentId) => {
    try {
      return await get(`api/studentinfos/${encodeURIComponent(studentId)}`);
      } catch (err) {
        console.error("Error checking student ID:", err);
        return false;
      }
  };
  
  // Get Student Basic info
  const getSimplifiedStudentInfoById = async (studentId) => {
    try{
      const response = await get(`api/studentinfos/basic-info?studentId=${encodeURIComponent(studentId)}`);
      return response;
    } catch (err) {
        console.error("Error checking student ID:", err);
        return false;
    }
  }

  return {
    fetchStudents,
    deleteStudent,
    addStudent,
    updateStudent,
    checkStudentIdExists,
    checkStudentExistsStudentIdFirstAndLastName,
    getStudentById,
    getSimplifiedStudentInfoById,
  };
}
